import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalTechnologyDeniedModel } from './types';
import { legalTechnologyDeniedItemValidator } from './validators/item';

const legalTechnologyDeniedValidator: ValidateJSModel<LegalTechnologyDeniedModel> = {
  HasDenied: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasDenied && attributes?.HasDenied.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalTechnologyDeniedItemValidator },
      };
    }
    return {};
  },
};
export default legalTechnologyDeniedValidator;
